<script>	
  import {
      fly,fade
  } from 'svelte/transition'; 
  export let id="";
  export let title="";
  export let subtitle="";
  export let href="";
  export let img="";
  export let parent=false;
  import Title from "../components/Title.svelte";
  import PerCategoryProduct from "../components/PerCategoryProduct.svelte"; 

  let uid = Math.random().toString(36).substring(2);
  let container;
  let opacity="opacity-100";
 function scroll(){
   container = document.querySelector('.cont-'+uid);

if(container.scrollLeft>100){ 
  opacity="opacity-0";
}
if(container.scrollLeft<=90){ 
  opacity="opacity-100";
}
 } 
</script>
 
<Title
      {title}
      {subtitle}
      tipe="3"
      {href} />
    <div class="relative overflow-hidden rounded-lg">
      <div  transition:fly={{x:-1000,delay:1000, duration: 500}}  class="lg:block hidden absolute w-64 h-full overflow-hidden transition-opacity ease-in-out duration-500 {opacity}">
          
        <div transition:fade={{duration: 200}} 
          class="h-full overflow-hidden relative block rounded-lg pr-0 bg-green-500 border-r-8 border-green-600">
          <img width="250" height="380"
            crossorigin="anonymous"
            class="w-full"
            src={img}
            alt="banner"/>
        </div> 

      </div>

      <div on:scroll={scroll} 
        class="dragcontainer lg:flex-no-wrap flex flex-no-wrap mt-2 py-3 md:mt-0 w-full overflow-x-auto lg:pl-56 relative  cont-{uid}">
        {#if parent}
          <PerCategoryProduct parent="true" id={id} />
        {:else} 
        <PerCategoryProduct id={id} />
    {/if}
      </div>
    </div>